<ul>
  <li *ngIf="hasHomePage">
    <a [routerLink]="defaultPages.homePage.url | localize">{{
      "pages_name." + defaultPages.homePage.pageNameKey | translate
    }}</a>
  </li>
  <li *ngFor="let page of _pages; let first = first">
    <svg-icon
      *ngIf="!first || hasHomePage"
      class="breadcrumb__separator"
      src="./assets/icons/right.svg"
    ></svg-icon>
    <a [routerLink]="'/' + page.url.join('/') | localize">{{
      page.labelKey ? (page.labelKey | translate) : page.label
    }}</a>
  </li>
</ul>
